(() => {
  const modal = document.querySelector('[data-minamiko-quick-add-modal]');
  if (!modal || modal.dataset.ready === 'true') return;

  modal.dataset.ready = 'true';
  const content = modal.querySelector('[data-minamiko-quick-add-content]');
  const addToCartLabel = modal.dataset.addToCartLabel;
  const soldOutLabel = modal.dataset.soldOutLabel;
  let lastTrigger = null;
  let closeTimer = null;

  const finishClose = () => {
    modal.hidden = true;
    modal.classList.remove('is-closing');
    content.innerHTML = '';
    document.documentElement.style.overflow = '';
    lastTrigger?.focus();
  };

  const closeModal = () => {
    if (modal.hidden || modal.classList.contains('is-closing')) return;
    modal.classList.add('is-closing');
    window.clearTimeout(closeTimer);
    const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
    closeTimer = window.setTimeout(finishClose, delay);
  };

  const updateVariant = (form, changedIndex = null, changedValue = null) => {
    const variants = JSON.parse(form.querySelector('[data-minamiko-variants]').textContent);
    const groups = [...form.querySelectorAll('[data-minamiko-option-group]')];
    let selected = groups.map((group) => group.querySelector('[data-minamiko-option][aria-pressed="true"]')?.value);
    let variant = selected.length
      ? variants.find((item) => item.available && item.options.every((value, index) => value === selected[index]))
      : variants.find((item) => item.available);

    if (!variant && changedIndex !== null) {
      variant = variants.find((item) => item.available && item.options[changedIndex] === changedValue);
      if (variant) {
        groups.forEach((group, index) => {
          group.querySelectorAll('[data-minamiko-option]').forEach((button) => {
            button.setAttribute('aria-pressed', button.value === variant.options[index] ? 'true' : 'false');
          });
        });
        selected = variant.options;
      }
    }

    groups.forEach((group, optionIndex) => {
      group.querySelectorAll('[data-minamiko-option]').forEach((button) => {
        button.disabled = !variants.some((item) => item.available && item.options.every((value, index) => {
          if (index === optionIndex) return value === button.value;
          return !selected[index] || value === selected[index];
        }));
      });
    });

    const idInput = form.querySelector('[name="id"]');
    const submit = form.querySelector('[name="add"]');
    idInput.value = variant ? variant.id : '';
    submit.disabled = !variant;
    submit.setAttribute('aria-disabled', variant ? 'false' : 'true');
    submit.textContent = variant ? addToCartLabel : soldOutLabel;

    if (!variant) return;

    const currentPrice = content.querySelector('[data-minamiko-current-price]');
    const comparePrice = content.querySelector('[data-minamiko-compare-price]');
    const image = content.querySelector('.minamiko-quick-add__image');
    currentPrice.textContent = variant.price;
    comparePrice.textContent = variant.compareAtPrice || '';
    comparePrice.hidden = !variant.compareAtPrice;
    if (variant.image) image.src = variant.image;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-minamiko-quick-add]');
    if (trigger) {
      const template = document.getElementById(trigger.dataset.minamikoQuickAdd);
      if (!template) return;
      event.preventDefault();
      lastTrigger = trigger;
      content.replaceChildren(template.content.cloneNode(true));
      modal.classList.remove('is-closing');
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const form = content.querySelector('form');
      if (form) {
        updateVariant(form);
        form.querySelectorAll('[data-minamiko-option]').forEach((button) => {
          button.addEventListener('click', () => {
            const group = button.closest('[data-minamiko-option-group]');
            group.querySelectorAll('[data-minamiko-option]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
            button.setAttribute('aria-pressed', 'true');
            updateVariant(form, Number(button.dataset.optionIndex), button.value);
          });
        });
      }
      requestAnimationFrame(() => modal.querySelector('.minamiko-quick-add__close').focus());
      return;
    }

    if (event.target.closest('[data-minamiko-quick-add-close]')) closeModal();
  });

  modal.addEventListener('on:cart:add', closeModal);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
